module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-ticad9-logo-055e99dfbcb09dac84593313f2084347.png";